import { Action } from '@ngrx/store';
import { StateUpdateFns } from 'ngrx-forms';
import {
  NgrxFormExtensionModel,
  HasNgrxForm
} from '@app/common/ngrx-forms-extensions';
import {
  TicketTextFormValue,
  TicketTextFormState
} from './ticket-text-form.model';
import { formKey } from './ticket-text-form.constant';

const formModel = new NgrxFormExtensionModel<TicketTextFormValue>(formKey);

export const getFormKey = (id: string) => formModel.getKey(id);

export const formState = (id: string) => (
  defaultValues: Partial<TicketTextFormValue> = {},
  updateFns: StateUpdateFns<TicketTextFormValue> = {}
) => ({
  [getFormKey(id)]: formModel.createFormState(
    id,
    {
      ticketMessage: undefined
    },
    defaultValues,
    updateFns
  )
});

export const applyFormReducer = <S extends HasNgrxForm>(
  state: S,
  action: Action,
  id: string,
  defaultSettings?: StateUpdateFns<TicketTextFormValue>
) => formModel.reduceAction(state, action, id, defaultSettings);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markAsSubmitted = (id: string, state: any) => formModel.markAsSubmitted(id, state);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const markAsUnsubmitted = (id: string, state: any) => formModel.markAsUnsubmitted(id, state);
export const formSelector = (id: string) => formModel.selectState<TicketTextFormState>(id);
export const formValueSelector = (id: string) => formModel.selectValue(id);
export const updateGroupAction = (
  id: string,
  value: Partial<TicketTextFormValue>
) => formModel.updateGroupValue(id, value);
